import React from "react";
import Sidebar from "../Components/Sidebar";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import { arrowup, uparrow } from "../Constant/Index";

function Editprofile() {
  return (
    <>
      <Header />
      <PageHeader pagename="edit profile" />
      {/* Profile Section  */}
      <section className="profile-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <Sidebar />
            </div>

            <div className="col-md-9">
              <div className="my-info-dv">
                <div className="row">
                  <div className="col-md-6">
                    <div className="my-info-head">
                      <h3 className="primary-color">edit profile info</h3>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="edit-profile-dv">
                      <button className="btn-all" style={{ width: "32%" }}>
                        save
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="info-border"></div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      {/* <label className="primary-color">First Name :</label>  */}
                      <h5 className="primary-color">First Name</h5>
                      <input type="text" placeholder="First Name" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">Last Name</h5>
                      <input type="text" placeholder="Last Name" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">Contact Number</h5>
                      <input type="number" placeholder="Phone Number" />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="name-info edit-input-info upload-dv">
                      <h5 className="primary-color">Upload Profile Pic</h5>
                      <input
                        style={{ position: "relative" }}
                        type="text"
                        placeholder="Img4455944566"
                      />
                      <div className="my-input-file-dv">
                        <input
                          style={{ border: "none" }}
                          type="file"
                          placeholder="Img4455944566"
                        />
                      </div>
                      <button >
                        <img src={uparrow}/>
                      </button>
                      {/* <img src={arrowup}/> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======================= */}
      <Footer />
    </>
  );
}

export default Editprofile;
